import React from "react";

const ThankyouPage = (props) => {
  return (
    <section
      className='viewerFormSection'
      style={{
        background: props?.color || "rgb(145 191 241)",
      }}
    >
      <div className='viewerFormTop viewerFormBox'>
        <div className='formTitle'>{props?.formTitle}</div>
        <div className='formDesc'>{props?.description}</div>
      </div>
      <div className='viewerFormTop viewerFormBox'>
        <span className='viewerQuestionTitle'>
          Thanks for filling out the response !
        </span>
      </div>
    </section>
  );
};

export default ThankyouPage;
